import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LeadManagementForm, LeadManagementResponse } from './interface';
import { selectForm } from './selector';
import { setLoading } from '../App/action';
import { LeadManagementAction } from './enum';
import { postLeadManagementForm, trackLeadManagementError } from './util/generator';
import { setLeadManagementError, setLeadManagementResult } from './action';
import { Address } from '@vfde-sails/avc-core';
import { selectSelectedAddress } from '../AddressValidation/selector';
import { trackLeadManagement } from '../../tracking/tracking';
import { LeadManagementTrigger } from '../../tracking/enum';

export function* submitLeadManagementFormSaga() {
    const form: LeadManagementForm = yield select(selectForm);
    const address: Address = yield select(selectSelectedAddress);

    try {
        yield put(setLoading(true));

        const response: LeadManagementResponse = yield call(postLeadManagementForm, form, address);

        yield put(setLeadManagementResult(response));
        yield call(trackLeadManagement, LeadManagementTrigger.ENGAGE);
    } catch (error) {
        if (error instanceof Error) {
            yield put(setLeadManagementError(error as Error));
            yield call(trackLeadManagementError);
        }
    }

    yield put(setLoading(false));
}

export default function* saga() {
    yield takeLatest(LeadManagementAction.SUBMIT, submitLeadManagementFormSaga);
}
